import React, { useEffect, useState } from 'react';
import LogIn from "../components/LogIn";
import './pages.sass';
import { useAppDispatch } from "../hooks/redux-hooks";
import { useNavigate } from "react-router-dom";
import { fetchGetCar } from "../store/slices/carSlice";

const LogInPage = () => {
    const dispatch = useAppDispatch();
    const navigation = useNavigate();

    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        // 1. Парсим UTM-параметры
        const params = new URLSearchParams(window.location.search);
        const utmName = params.get('name'); // или utm_name
        const utmVin = params.get('vin');   // или utm_vin

        // 2. Сохраняем в localStorage, если есть
        if (utmName) localStorage.setItem('carName', utmName);
        if (utmVin) localStorage.setItem('carVIN', utmVin);

        // 3. Считываем из localStorage
        const name = localStorage.getItem('carName');
        const VIN = localStorage.getItem('carVIN');

        // 4. Пробуем авторизоваться
        if (name && VIN) {
            dispatch(fetchGetCar({ name, VIN }))
                .unwrap()
                .then(() => navigation('/main'))
                .catch((error) => {
                    // Ошибка — очищаем и отправляем на стартовую страницу
                    //setErrorMessage(error || 'Произошла ошибка при авторизации');
                    localStorage.removeItem('carName');
                    localStorage.removeItem('carVIN');
                    window.location.href = '/'; // или '/auth', если другая стартовая
                });
        }
    }, [dispatch, navigation]);

    return (
        <div className={'login_page_container'}>
            <LogIn />
            {errorMessage && (
                <div className="error-message">
                    <p>{errorMessage}</p>
                </div>
            )}
        </div>
    );
};

export default LogInPage;